"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _RangeFilter = _interopRequireDefault(require("../RangeFilter"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var clinicianPayerContractListConfig = function clinicianPayerContractListConfig(dataSource) {
  var columns = [{
    title: 'Payer Name',
    dataIndex: 'payerContract.payer.payerName',
    key: 'payerContract.payer.payerName',
    sorter: (0, _utils.stringSorter)('payerContract.payer.payerName'),
    width: 150
  }, {
    title: 'Payer CPID',
    dataIndex: 'payerContract.payer.cpid',
    key: 'payerContract.payer.cpid',
    sorter: (0, _utils.stringSorter)('payerContract.payer.cpid'),
    width: 150
  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (0, _utils.stringSorter)('status'),
    width: 150
  }, {
    title: 'Billing Taxonomy Code',
    dataIndex: 'clinicianBillingTaxonomyCode',
    key: 'clinicianBillingTaxonomyCode',
    sorter: (0, _utils.stringSorter)('clinicianBillingTaxonomyCode'),
    width: 150
  }, {
    title: 'Effective Date',
    dataIndex: 'effectiveDate',
    key: 'effectiveDate',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('effectiveDate'),
    render: function render(id, record) {
      return (0, _utils.formatDate)(record.effectiveDate, {
        utc: true
      });
    },
    sorter: (0, _utils.timeSorter)('effectiveDate'),
    width: 150
  }, {
    title: 'Payer Contract Geography',
    dataIndex: 'payerContract.geography',
    key: 'payerContract.geography',
    sorter: (0, _utils.stringSorter)('payerContract.geography'),
    width: 150
  }, {
    title: 'Payer Contract Effective Date',
    dataIndex: 'payerContract.effectiveDate',
    key: 'payerContract.effectiveDate',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('payerContract.effectiveDate'),
    render: function render(id, record) {
      return (0, _utils.formatDate)(record.payerContract.effectiveDate, {
        utc: true
      });
    },
    sorter: (0, _utils.timeSorter)('payerContract.effectiveDate'),
    width: 150
  }, {
    title: 'Payer Contract Expiration Date',
    dataIndex: 'payerContract.expirationDate',
    key: 'payerContract.expirationDate',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('payerContract.expirationDate'),
    render: function render(id, record) {
      return (0, _utils.formatDate)(record.payerContract.expirationDate, {
        utc: true
      });
    },
    sorter: (0, _utils.timeSorter)('payerContract.expirationDate'),
    width: 150
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = clinicianPayerContractListConfig;
exports.default = _default;